// ServicesPage.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import axios from "axios";

const ProductsPage = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategories();
  }, []);

  const getCategories = async () => {
    try {
      const res = await axios.get(
        "https://test.bioversalremedies.com/bioversal_remedies_admin/api/categories-data"
      );
      setCategories(res.data.data || []);
    } catch (error) {
      console.log("Category API error:", error);
    }
  };

  // Convert category name into URL slug
  const makeSlug = (name) =>
    name
      .toLowerCase()
      .trim()
       .replace(/&/g, "and")     // change & → and
    .replace(/\//g, "-")      // change / → -
    .replace(/\s+/g, "-")     // spaces → dash
    .replace(/[^a-z0-9-]/g, ""); // remove anything else

  return (
    <div>
      <Seo
        title="Discover Our Best Quality Product List | Query Now!"
        description="Discover our extensive product list filled with high-quality items to meet all your needs. We deals in PPI’s, Derma,Dental etc. Call now!"
        type="webapp"
        name="Bioversal Remedies"
      />

      <section className="animate__animated animate__fadeIn">
        <div className="container-fluid mt-5 p-0">
          <div className="bg_cont__45__products ban__nerrr">
            <h2 style={{ color: "#fff", zIndex: "99" }}>Our Products</h2>
          </div>
        </div>

        <div className="container my-5">
          <div className="d-flex justify-content-center flex-wrap">

            {categories.map((item) => {
              const slug = makeSlug(item.name);

              return (
                <div className="feature-bx-category" key={item.id}>
                  <Link
                    to={`/categories/${slug}`}
                    style={{ textDecoration: "none", color: "#fff" }}
                  >
                    <div className="feature-cat-content">

                      {/* Image added here */}
                      <div className="mb-2 text-center">
                       <img
							  src={item.image}
							  alt={item.name}
							  style={{
								width: "50px",
								height: "50px",
								objectFit: "cover",
								borderRadius: "100px",
								marginRight: "25px"
							  }}
							/>
                      </div>

                      <div>
                        <h4 className="ttr-title">{item.name}</h4>
                        <p>Explore our {item.name} range.</p>
                      </div>

                      <Link
                        to={`/categories/${slug}`}
                        className="btn feature-cat-btn"
                      >
                        <i className="fa fa-plus-circle"></i>
                      </Link>
                    </div>
                  </Link>
                </div>
              );
            })}

          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
